export default __webpack_public_path__ + "static/media/dashboard1.6afd07f5.png";